import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { toLocalInput } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SelectBox } from "@/components/common/ui";

const TYPES = [["follow_up", "Follow-up"], ["call", "Call"], ["visit", "Site / store visit"], ["email", "Email"], ["meeting", "Meeting"], ["other", "Other"]];

export default function TaskDialog({ open, onOpenChange, leadId, onSaved }) {
  const { can, people } = useAuth();
  const [f, setF] = useState({ title: "", type: "follow_up", due_at: toLocalInput(), assigned_to: "" });
  useEffect(() => { if (open) setF({ title: "", type: "follow_up", due_at: toLocalInput(), assigned_to: "" }); }, [open]);

  const save = async () => {
    try {
      await api.post("/tasks", { lead_id: leadId, title: f.title, type: f.type, due_at: new Date(f.due_at).toISOString(), assigned_to: f.assigned_to || null });
      toast.success("Follow-up scheduled");
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="task-dialog">
        <DialogHeader><DialogTitle>Schedule follow-up</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label>Title</Label><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="e.g. Call to confirm roof measurements" data-testid="task-title-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Type</Label><SelectBox value={f.type} onChange={(v) => setF({ ...f, type: v || "follow_up" })} testid="task-type-select" className="w-full" options={TYPES.map(([v, l]) => ({ value: v, label: l }))} /></div>
            <div className="space-y-1.5"><Label>Due</Label><Input type="datetime-local" value={f.due_at} onChange={(e) => setF({ ...f, due_at: e.target.value })} data-testid="task-due-input" /></div>
          </div>
          {can("leads.assign") && (
            <div className="space-y-1.5"><Label>Assign to</Label><SelectBox value={f.assigned_to} onChange={(v) => setF({ ...f, assigned_to: v })} testid="task-assign-select" className="w-full" allLabel="Lead's salesperson" options={people.filter((p) => p.assignable).map((p) => ({ value: p.id, label: p.name }))} /></div>
          )}
        </div>
        <DialogFooter><Button onClick={save} disabled={!f.title.trim() || !f.due_at} className="bg-orange-500 hover:bg-orange-600" data-testid="task-save-button">Schedule</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
